import type { FaireProductEntity } from "../../entity_types/product";

export const p_h692bkg9yn: FaireProductEntity = {
  token: "p_h692bkg9yn",
  type: "product",
  name: "Crags Single Color Case Pack",
  brandToken: "b_vw97v1k7ax",
  brandName: "Speks",
  imageUrl:
    "https://cdn.faire.com/fastly/f3f63d104ffe65a05d49da973a2a74ad91602f996688860234bc75a1ac8ad3d6.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/604da7cf1dc6eed424e38d663aca663138edbb9664bef8d446e6a56617434ef0.png",
    "https://cdn.faire.com/fastly/d12723bacb0f7a140090b9f28e04f67c4eea54fab006eb4f04887c0f2cdf58c5.png",
    "https://cdn.faire.com/fastly/e396559c3aeda9ffcc6203e4a766b7ab817fa826d73fb461adb4ef0c4cb94f24.png",
    "https://cdn.faire.com/fastly/ae919d167ded235ffa9c3c5e438336983a6aacdfa9ef5b7e6bb623b6a03d2295.png",
    "https://cdn.faire.com/fastly/7e5e8380f8cbc69ccbb6c0a536038a3cbcafe9a183d3840e17c279c3c92e372b.jpeg",
    "https://cdn.faire.com/fastly/f0e64e267abcdc53ba54f991d21ad91cd49bd878ded7e49b3f233cb58fb3f111.jpeg",
    "https://cdn.faire.com/fastly/13cf7c47eb58e70e5799f877dcb62720e2a5c5f8931579894703a3a3b45b9ab5.jpeg",
    "https://cdn.faire.com/fastly/3b01ca5a3c16e5228a48ab478671ba2afb1386d69b9b8c3c717c59a82e036aa6.jpeg",
    "https://cdn.faire.com/fastly/efd818f74ea20f8ffc3610bfab1c3395c6d78264eda378b57229994b29a0b405.png",
    "https://cdn.faire.com/fastly/b2504f12b796025197acd6716ba10811e0908961b87a5db77731f9fee76be53a.jpeg",
  ],
  priceDollars: 13.5,
  description:
    'Crags are an oddly satisfying magnetic fidget putty that you won’t be able to put down!\nRun these super smooth magnetic stones through your fingers for the ultimate stress relief.\n\nEach box measures 3.75" x 3.75" x 1.5".',
  tags: [],
  msrpDollars: 26.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:58:43.520Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
